import React from 'react';
const defaultContextValue = {
  location: {},
  history: {},
  match: {},
  staticContext: {}
};
export default /*#__PURE__*/React.createContext(defaultContextValue);